<template>
  <div>
    <v-layout row align-center>
      <v-flex>
        <b>{{ notification.name }}</b>
        <p>{{ notification.description }}</p>
        <div>
          Currently
          <span
            v-if="
              notification.NotificationSetting &&
              notification.NotificationSetting.metadata &&
              notification.NotificationSetting.metadata.phoneNumbers
            "
            >{{
              notification.NotificationSetting.metadata.phoneNumbers.length
            }}</span
          >
          <span v-else>0</span> Phone number(s) set.
        </div>
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn
        v-if="notification.NotificationSetting"
        class="v-btn-with-radius"
        color="primary"
        dark
        @click="open()"
        >Edit</v-btn
      >
      <div v-if="!notification.NotificationSetting">
        <v-btn class="v-btn-with-radius" color="primary" @click="open()">{{
          $t("buttons.enable")
        }}</v-btn>
      </div>
      <div v-else>
        <v-btn
          class="v-btn-with-radius"
          color="error"
          @click="disableNotification(notification)"
          >Disable</v-btn
        >
      </div>
    </v-layout>
    <v-dialog persistent v-model="dialog" max-width="700px">
      <v-card :color="$style.card.background">
        <CardToolbar
          title="Invoice Delete Alert"
          :isModal="true"
          @cancel="cancel"
        />
        <v-container grid-list-md>
          <v-layout column>
            <v-flex>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-layout column>
                    <v-flex>
                      <div>Phone Number</div>
                      <div><small>limit 2 number</small></div>
                      <v-layout row>
                        <v-flex>
                          <v-text-field
                            outlined
                            clearable
                            :hide-details="phoneNumberErrors.length === 0"
                            :error-messages="phoneNumberErrors"
                            mask="phone"
                            dense
                            v-model="invoiceAlertDialog.phoneNumber"
                          ></v-text-field>
                        </v-flex>
                        <v-flex shrink>
                          <v-btn
                            class="v-btn-with-radius mt-0"
                            @click="addDeleteAlertPhoneNumber"
                            :disabled="
                              $v.invoiceAlertDialog.$invalid ||
                              invoiceDeletedAlert.phoneNumbers.length > 1
                            "
                            >Add</v-btn
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex>
                      <v-list v-if="invoiceDeletedAlert.phoneNumbers.length">
                        <template
                          v-for="(
                            number, index
                          ) in invoiceDeletedAlert.phoneNumbers"
                        >
                          <v-list-item :key="number">
                            <v-list-item-action>
                              <v-btn
                                fab
                                flat
                                @click.stop.prevent="deletePhoneNo(index)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-list-item-action>
                            <v-list-item-content>{{
                              number | phone
                            }}</v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout
                row
                wrap
                align-center
                v-if="invoiceDeletedAlert.phoneNumbers.length"
              >
                <v-flex xs12 md9>
                  <span class="font-weight-medium">{{
                    $t("labels.invoiceDeleteAlert")
                  }}</span>
                  <p class="font-weight-light">
                    {{ $t("subTitle.deleteInvoiceAlert") }}
                  </p>
                </v-flex>
                <v-flex shrink xs12 md3 lg2>
                  <v-switch
                    v-model="invoiceDeletedAlert.sendDeleteAlert"
                    color="primary"
                    :label="
                      invoiceDeletedAlert.sendDeleteAlert
                        ? 'Enabled'
                        : 'Disabled'
                    "
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>

        <CardActions
          name="editAlert"
          @submit="submit"
          :loading="submitLoading"
          :disabled="
            invoiceDeletedAlert.phoneNumbers.length === 0 ? true : false
          "
          @cancel="cancel"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import locationService from "@/modules/Location/service.js";

import timePicker from "@/components/Controls/TimePicker.vue";

const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");

export default {
  props: ["notification", "LocationId"],
  data() {
    return {
      submitLoading: false,
      invoiceAlertDialog: {
        phoneNumber: "",
        time: null,
      },
      invoiceDeletedAlert: {
        phoneNumbers: [],
        times: [],
        service: "twilio",
        sendDeleteAlert: false,
      },
      dialog: false,
      enableNotification: {},
    };
  },
  components: {
    timePicker,
  },
  watch: {
    invoiceDeletedAlert: {
      handler(val) {
        // disable switch if no phoneNumber is given.
        if (val.phoneNumbers && val.phoneNumbers.length == 0)
          val.sendDeleteAlert = false;
      },
      deep: true,
    },
  },
  computed: {
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.invoiceAlertDialog.phoneNumber.$dirty) return errors;
      if (!this.$v.invoiceAlertDialog.phoneNumber.required)
        errors.push("Field is required");
      if (!this.$v.invoiceAlertDialog.phoneNumber.minLength)
        errors.push(this.$t("validations.validLetters10"));
      return errors;
    },
  },
  methods: {
    async disableNotification() {
      this.$swal
        .fire({
          title: this.$t("messages.title.areYouSure"),
          text: this.$t("messages.text.disableInvoiceDeleteNotification"),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then(async (result) => {
          if (result.value) {
            await locationService.Settings.Notifications.remove(
              this.LocationId,
              this.notification.NotificationSetting.id
            )
              .then(() => {
                this.$emit("reload");
                this.$swal.fire(
                  this.$t("messages.title.disabled"),
                  "",
                  "success"
                );
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
    },
    cancel() {
      this.reset();
      this.dialog = false;
    },
    open() {
      this.dialog = true;
      this.enableNotification.NotificationSetting = {
        NotificationId: this.notification.id,
        metadata: {},
        ...this.notification.NotificationSetting,
      };

      if (this.notification.NotificationSetting) {
        this.invoiceDeletedAlert.phoneNumbers = JSON.parse(
          JSON.stringify(
            this.notification.NotificationSetting.metadata.phoneNumbers
          )
        );
        this.invoiceDeletedAlert.times = JSON.parse(
          JSON.stringify(this.notification.NotificationSetting.metadata.times)
        );
        this.invoiceDeletedAlert.sendDeleteAlert = JSON.parse(
          JSON.stringify(
            this.notification.NotificationSetting.metadata.sendDeleteAlert
          )
        );
      }
    },
    async submit() {
      console.log("submit buton press");
      // if (this.invoiceDeletedAlert.phoneNumbers.length === 0) {
      //   this.$swal
      //     .mixin({
      //       toast: true,
      //       showConfirmButton: true,
      //       position: 'top-end',
      //       timer: 3000,
      //     })
      //     .fire({
      //       type: 'error',
      //       title: 'Please add phone to list.',
      //     })
      //   return false
      // }
      this.enableNotification.NotificationSetting = {
        ...this.enableNotification.NotificationSetting,
        metadata: this.invoiceDeletedAlert,
      };
      this.submitLoading = true;
      await locationService.Settings.Notifications.set(
        this.LocationId,
        this.enableNotification.NotificationSetting
      );
      this.submitLoading = false;
      this.$swal
        .mixin({
          toast: true,
          showConfirmButton: true,
          position: "top-end",
          timer: 3000,
        })
        .fire({
          type: "success",
          title: this.$t("toastMessage.text.updated"),
        });
      this.cancel();
      this.$emit("reload");
    },
    async deletePhoneNo(index) {
      this.$swal
        .fire({
          title: this.$t("messages.title.areYouSure"),
          text: this.$t("messages.text.youWontBeAbleToRevert"),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("buttons.yesDeleteIt"),
        })
        .then((result) => {
          if (result.value) {
            this.invoiceDeletedAlert.phoneNumbers.splice(index, 1);
            this.$swal.fire(
              this.$t("messages.title.deleted"),
              this.$t("messages.text.phoneNumberDeleted"),
              "success"
            );
            this.submit();
          }
        });
    },
    convertTime(hh, mm, a) {
      let hours = Number(hh);
      const minutes = Number(mm);
      const AMPM = a;
      if (AMPM == "PM" && hours < 12) hours += 12;
      if (AMPM == "AM" && hours == 12) hours -= 12;
      let sHours = hours.toString();
      let sMinutes = minutes.toString();
      if (hours < 10) sHours = `0${sHours}`;
      if (minutes < 10) sMinutes = `0${sMinutes}`;
      return `${sHours}:${sMinutes}`;
    },
    reset() {
      this.invoiceAlertDialog.phoneNumber = "";
      this.enableNotification = {};
      this.$v.$reset();
    },
    addDeleteAlertPhoneNumber() {
      if (this.invoiceAlertDialog.phoneNumber.length === 0) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$swal
            .mixin({
              toast: true,
              showConfirmButton: true,
              position: "top-end",
              timer: 3000,
            })
            .fire({
              type: "error",
              title: this.$t("toastMessage.text.missingFields"),
            });
        }
      } else {
        if (
          this.invoiceDeletedAlert.phoneNumbers.indexOf(
            this.invoiceAlertDialog.phoneNumber
          ) !== -1
        ) {
          this.$swal
            .mixin({
              toast: true,
              showConfirmButton: true,
              position: "top-end",
              timer: 3000,
            })
            .fire({
              type: "error",
              title: this.$t("toastMessage.text.phoneNumberAlreadyExist"),
            });
          return false;
        }

        this.invoiceDeletedAlert.phoneNumbers.push(
          this.invoiceAlertDialog.phoneNumber
        );
        this.invoiceAlertDialog.phoneNumber = null;
      }
    },
  },
  mixins: [validationMixin],
  validations: {
    invoiceAlertDialog: {
      phoneNumber: {
        required,
        minLength: minLength(10),
      },
    },
  },
};
</script>
